@if (isDesignationListLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  <form [formGroup]="employeeForm" (ngSubmit)="onSubmitEmployeeForm()" enctype="multipart/form-data">
    <div class="modal-body row g-3">
      <app-error-alert [error]="apiError" (onClose)="apiError = null"></app-error-alert>
      @if (mode === Action.CREATE) {
        <div class="col-12 mt-1">
          <div class="alert alert-info d-flex align-items-center my-0" role="alert">
            <i class="bi bi-info-circle-fill me-2"></i>
            <div>
              <strong>Password Requirements:</strong>
              Password must be at least 8 characters long and include an uppercase letter, a number, and a special
              character. (e.g.
              <u>Enjochem&#64;12345</u>
              )
            </div>
          </div>
        </div>
      }
      <div class="col-md-4">
        <label>Profile Picture</label>
        <input type="file" class="form-control" (change)="onProfilePictureSelected($event)" accept="image/*" />
        <div *ngIf="previewProfilePicture" class="mt-2">
          <img
            [src]="previewProfilePicture"
            alt="Profile Picture Preview"
            class="img-thumbnail"
            width="100"
            height="100" />
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Email
          <span class="text-danger">*</span>
        </label>
        <input type="email" class="form-control" formControlName="email" />
        <div
          *ngIf="employeeForm.get('email')?.touched && employeeForm.get('email')?.invalid"
          class="text-danger small mt-1">
          <div *ngIf="employeeForm.get('email')?.errors?.['required']">Email is required.</div>
          <div *ngIf="employeeForm.get('email')?.errors?.['email']">Enter a valid email.</div>
        </div>
      </div>

      @if (mode === Action.CREATE) {
        <div class="col-md-4">
          <label>
            Password
            <span class="text-danger">*</span>
          </label>
          <div class="password-field">
            <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password" />
            <button
              type="button"
              class="password-toggle-btn"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
              [attr.aria-pressed]="showPassword"
              (click)="showPassword = !showPassword">
              <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>

          <div
            *ngIf="employeeForm.get('password')?.touched && employeeForm.get('password')?.invalid"
            class="text-danger small mt-1">
            <div *ngIf="employeeForm.get('password')?.errors?.['required']">Password is required.</div>
          </div>
        </div>
      }

      <div class="col-md-4">
        <label>
          First Name
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="first_name" />
        <div
          *ngIf="employeeForm.get('first_name')?.touched && employeeForm.get('first_name')?.invalid"
          class="text-danger small mt-1">
          First Name is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Last Name
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="last_name" />
        <div
          *ngIf="employeeForm.get('last_name')?.touched && employeeForm.get('last_name')?.invalid"
          class="text-danger small mt-1">
          Last Name is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Phone Number
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="phone_number" />
        <div
          *ngIf="employeeForm.get('phone_number')?.touched && employeeForm.get('phone_number')?.invalid"
          class="text-danger small mt-1">
          Phone Number is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Role
          <span class="text-danger">*</span>
        </label>
        <ng-select
          placeholder="Select Role"
          [items]="roleOptions"
          formControlName="role"
          bindValue="code"
          bindLabel="name"
          [clearable]="false"
          [searchable]="false" />
        <div
          *ngIf="employeeForm.get('role')?.touched && employeeForm.get('role')?.invalid"
          class="text-danger small mt-1">
          Role is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Designation
          <span class="text-danger">*</span>
        </label>
        <ng-select
          placeholder="Select Designation"
          [items]="designations"
          formControlName="designation"
          bindValue="id"
          bindLabel="title"
          [clearable]="false"
          [searchable]="true" />
        <div
          *ngIf="employeeForm.get('designation')?.touched && employeeForm.get('designation')?.invalid"
          class="text-danger small mt-1">
          Designation is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Date of Birth
          <span class="text-danger">*</span>
        </label>
        <input type="date" class="form-control" formControlName="date_of_birth" />
        <div
          *ngIf="employeeForm.get('date_of_birth')?.touched && employeeForm.get('date_of_birth')?.invalid"
          class="text-danger small mt-1">
          Date of Birth is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Date of Joining
          <span class="text-danger">*</span>
        </label>
        <input type="date" class="form-control" formControlName="date_of_joining" />
        <div
          *ngIf="employeeForm.get('date_of_joining')?.touched && employeeForm.get('date_of_joining')?.invalid"
          class="text-danger small mt-1">
          Date of Joining is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Aadhar Card Number
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="aadhar_card_number"
          placeholder="Enter 12 digit number" />
        <div
          *ngIf="employeeForm.get('aadhar_card_number')?.touched && employeeForm.get('aadhar_card_number')?.invalid"
          class="text-danger small mt-1">
          <div *ngIf="employeeForm.get('aadhar_card_number')?.errors?.['required']">
            Aadhar Card Number is required.
          </div>
          <div *ngIf="employeeForm.get('aadhar_card_number')?.errors?.['pattern']">
            Aadhar Card Number must be 12 digits.
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Address Line 1
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="address_line1" />
        <div
          *ngIf="employeeForm.get('address_line1')?.touched && employeeForm.get('address_line1')?.invalid"
          class="text-danger small mt-1">
          Address Line 1 is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>Address Line 2</label>
        <input type="text" class="form-control" formControlName="address_line2" />
      </div>

      <div class="col-md-4">
        <label>
          City
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="city" />
        <div
          *ngIf="employeeForm.get('city')?.touched && employeeForm.get('city')?.invalid"
          class="text-danger small mt-1">
          City is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Postal Code
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="postal_code" />
        <div
          *ngIf="employeeForm.get('postal_code')?.touched && employeeForm.get('postal_code')?.invalid"
          class="text-danger small mt-1">
          Postal Code is required.
        </div>
      </div>

      <div class="col-md-4">
        <label>
          Country
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="country" />
        <div
          *ngIf="employeeForm.get('country')?.touched && employeeForm.get('country')?.invalid"
          class="text-danger small mt-1">
          Country is required.
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onCancelEvent.emit()">
        <i class="bi bi-x-circle"></i>
        <span>Cancel</span>
      </button>

      <button type="submit" class="btn btn-primary btn-enjochem" [disabled]="employeeForm.invalid">
        <ng-container *ngIf="isSavingEmployeeInfo; else saveIcon">
          <app-loading-spinner [textClass]="'text-white'" [inline]="true" class="me-1"></app-loading-spinner>
        </ng-container>

        <ng-template #saveIcon>
          <i class="bi bi-box-arrow-down"></i>
        </ng-template>

        <span>Save</span>
      </button>
    </div>
  </form>
}
